<template>
    <div>
     {{msg}}
    </div>
</template>
<script>
import getData from "../service/getData";
import api from "../service/api";

export default {
  data: function() {
    return {
      msg: ""
    };
  },
  mounted() {
    this.getParams();
  },
  methods: {
    getParams: async function() {
      const uid = this.$route.query.uid;
      const role = this.$route.query.role;
      const region = this.$route.query.region;
      const ts = this.$route.query.ts;
      const sign = this.$route.query.sign;

      const type = this.$route.query.type;
      if (type) {
        //inside用来区别类型
        sessionStorage.setItem("type", type);
      }
      if (region) {
        //根据区域查找
        sessionStorage.setItem("region", region);
      }

      const data = { uid, role, region, ts, sign, type };
            const res = await getData.get(api.login, data);

      if (res.data && res.data.status) {
        sessionStorage.setItem("token", res.data.token);
        sessionStorage.setItem("userId", res.data.user_id);
        sessionStorage.setItem("role", res.data.role);
        sessionStorage.setItem("roleCode", res.data.roleCode);
        sessionStorage.setItem("userIds", JSON.stringify(res.data.user_ids));
        sessionStorage.setItem("users", JSON.stringify(res.data.users));

        if (
          this.$route.query.redirect &&
          ["Map", "Customers", "Members"].indexOf(this.$route.query.redirect) >
            -1
        ) {
          this.$router.push({ path: `/${this.$route.query.redirect}` });
        } else {
          this.$router.push({ path: "/customers" });
        }
      } else {
        if (res.data) {
          this.msg = res.data.msg;
        } else {
          this.msg = "服务器错误";
        }
        this.$Message.info(this.msg);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Login.vue